import { render, staticRenderFns } from "./ResetPassword2.vue?vue&type=template&id=483afe98"
import script from "./ResetPassword2.vue?vue&type=script&lang=ts"
export * from "./ResetPassword2.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports